import React from 'react';

import { SVGComponentProps } from './svg.types';

const PrivateSVG = ({
  stroke = 'currentColor',
  size = '1em',
  ...otherProps
}: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M2.66675 3.33334V2.66668C2.66675 2.31305 2.80722 1.97392 3.05727 1.72387C3.30732 1.47382 3.64646 1.33334 4.00008 1.33334H9.66675L13.3334 5.00001V13.3333C13.3334 13.687 13.1929 14.0261 12.9429 14.2762C12.6928 14.5262 12.3537 14.6667 12.0001 14.6667H2.66675"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33325 1.33334V5.33334H13.3333"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99992 8.66666H1.99992C1.63173 8.66666 1.33325 8.96513 1.33325 9.33332V11.3333C1.33325 11.7015 1.63173 12 1.99992 12H5.99992C6.36811 12 6.66658 11.7015 6.66658 11.3333V9.33332C6.66658 8.96513 6.36811 8.66666 5.99992 8.66666Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33341 8.66667V7.33333C5.33341 6.97971 5.19294 6.64057 4.94289 6.39052C4.69284 6.14048 4.3537 6 4.00008 6C3.64646 6 3.30732 6.14048 3.05727 6.39052C2.80722 6.64057 2.66675 6.97971 2.66675 7.33333V8.66667"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PrivateSVG;
